export default __webpack_public_path__ + "static/media/main-banner.f9c7bf09.jpeg";